// export default {
//   items: [
//     {
//       name: 'Home',
//       url: '/home',
//       icon: 'fa fa-home',
//     },
//     // {
//     //   name: 'Skills',
//     //   url: '/skills',
//     //   icon: 'fa fa-microphone',
     
//     // },
//     {
//       name: 'Profile',
//       url: '/profile',
//       icon: 'fa fa-address-book ',
     
//     },
//     {
//       name: 'User Management',
//       url: '/roles',
//       icon: 'fa fa-users',
//       children: [
//         {
//           name: "Users",
//           url: "/users",
//           icon: "fa fa-user",
//         },
//         {
//           name: "Roles/Permissions",
//           url: "/roles/",
//           icon: "fa fa-lock",
//         },
        
//       ]
//     },
	  // {
    //   name: 'Promote your Bot',
    //   url: '/promoteyourbot',
    //   icon: 'fa fa-bullhorn',

    // },
    // {
    //   name: 'Help Us  Improve',
    //   url: '/feedback',
    //   icon: 'fa fa-comments',

    // },
  //    {
  //     name: 'Administration',
  //     url: '/administration',
  //     icon: 'cui-screen-desktop',
  //     children: [
  //       {
  //         name: 'Dropdowns',
  //         url: '/administration/dropdowns',
  //         icon: 'cui-chevron-bottom'
  //       },
  //       {
  //         name: 'Users',
  //         url: '/administration/users',
  //         icon: 'fa fa-users'
  //       },
  //       {
  //         name: 'Roles',
  //         url: '/administration/roles',
  //         icon: 'fa fa-cog'
  //       },
  //     ]
  //   },
    
  //   {
  //     name: 'Skill Templates',
  //     url: '/skilltemplates',
  //     icon: 'fa fa-feed',
  //   },
  //   {
  //     name: 'Voice Skills',
  //     url: '/voiceskills',
  //     icon: 'fa fa-feed',
  //   },
  //   {
  //     name: 'Reports',
  //     url: '/reports',
  //     icon: 'fa fa-file',
  //     children: [
  //       {
  //         name: 'Activity Log',
  //         url: '/reports/activitylog',
  //         icon: 'fa fa-history'
  //       },
  //     ]
  //   },
//   ]
// };

import React, { useState, useEffect } from "react";
import axios from "./containers/Axios/Config";
import _ from "lodash";

function switchFunction(key) {
  switch (key) {
    case "profile":
      return {
            name: 'Profile',
            url: '/profile',
            icon: 'fa fa-address-book ',
      };
    default:
      return false;
  }
}

function switchUserMgmtSubmenuFunction(key) {
  switch (key) {
    case "users":
      return {
        name: "Users",
        url: "/users/",
        icon: "fa fa-user",
      };
    case "permissions":
      return {
        name: "Roles/Permissions",
        url: "/roles/",
        icon: "fa fa-lock",
      };

    default:
      return false;
  }
}


export const test = () => {
  let userId = localStorage.getItem("iotUser");
  if (userId) {
    return axios
      .get("/get/user/permissions/"+userId)
      .then((res) => {
        let items = [
          {
            name: "Home",
            url: "/home",
            icon: "fa fa-home",
            mainmenuId: 1,
          }
        ];
        let user_management = {
          name: "User Management",
          url: "/users",
          icon: "fa fa-users",
          children: [],
          mainmenuId: 4,
        };
        
        _.map(res.data.data.userRole, (option, key) => {
          if (option.canView && option.isMenu) {
            let returnSwitchdata = switchFunction(key);
            if (returnSwitchdata) {
              items.push(returnSwitchdata);
            }
          }  else if (
            option.canView &&
            !option.isMenu &&
            option.parent === "user_management" &&
            res.data.data.userRole.user_management.canView
          ) {
            let returnDropdownData = switchUserMgmtSubmenuFunction(key);
            if (returnDropdownData) {
              user_management.children.push(returnDropdownData);
            }
          }
        });
        if (user_management.children.length > 0) {
          items.push(user_management);
        }
        items.sort(function (a, b) {
          return a.mainmenuId - b.mainmenuId;
        });

        let data = { data: { items }, status: res.status };
        return data;
      })
      .catch((error) => {
        let err = { msg: error };
        console.log(err)
        return err;
      });
  }
};
